import { render, staticRenderFns } from "./ProjectRiskCreateDialog.vue?vue&type=template&id=0bca58f0&scoped=true"
import script from "./ProjectRiskCreateDialog.vue?vue&type=script&lang=js"
export * from "./ProjectRiskCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectRiskCreateDialog.vue?vue&type=style&index=0&id=0bca58f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca58f0",
  null
  
)

export default component.exports